var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanner02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 389,
    height: 79,
    viewBox: "0 0 389 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "banner02",
    transform: "translate(-11.465 -68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "banner2_01",
    transform: "translate(-153.535 -46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57943",
    "data-name": "Group 57943",
    transform: "translate(363 114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57945",
    "data-name": "Group 57945",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11641",
    "data-name": "Rectangle 11641",
    width: 191,
    height: 79,
    rx: 5,
    transform: "translate(0)",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58058",
    "data-name": "Group 58058",
    transform: "translate(-9.619 -9.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57944",
    "data-name": "Group 57944",
    transform: "translate(75 34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53600",
    "data-name": "Path 53600",
    d: "M258.81,97.184,243.085,81.46a2.156,2.156,0,0,0-3.049,0L220,101.5h43.634Z",
    transform: "translate(-203.396 -79.744)",
    fill: "#e7e9ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53602",
    "data-name": "Path 53602",
    d: "M219.58,85.773,204.6,100.547a2.144,2.144,0,0,0,1.511.621h30.185l-13.47-15.395A2.157,2.157,0,0,0,219.58,85.773Z",
    transform: "translate(-204.598 -79.415)",
    fill: "#1a2d4c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_833",
    "data-name": "Ellipse 833",
    cx: 3.377,
    cy: 3.498,
    rx: 3.377,
    ry: 3.498,
    transform: "translate(21.709 0)",
    fill: "#e7e9ed"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_53684",
    "data-name": "Path 53684",
    d: "M0,0H60.238",
    transform: "translate(65.381 53.948)",
    fill: "none",
    stroke: "#e7e9ed",
    strokeLinecap: "round",
    strokeWidth: 5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "banner2_02",
    transform: "translate(-351.535 -46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57943-2",
    "data-name": "Group 57943",
    transform: "translate(363 114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57945-2",
    "data-name": "Group 57945",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11641-2",
    "data-name": "Rectangle 11641",
    width: 191,
    height: 79,
    rx: 5,
    transform: "translate(0)",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58058-2",
    "data-name": "Group 58058",
    transform: "translate(-9.619 -9.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57944-2",
    "data-name": "Group 57944",
    transform: "translate(75 34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53600-2",
    "data-name": "Path 53600",
    d: "M258.81,97.184,243.085,81.46a2.156,2.156,0,0,0-3.049,0L220,101.5h43.634Z",
    transform: "translate(-203.396 -79.744)",
    fill: "#e7e9ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53602-2",
    "data-name": "Path 53602",
    d: "M219.58,85.773,204.6,100.547a2.144,2.144,0,0,0,1.511.621h30.185l-13.47-15.395A2.157,2.157,0,0,0,219.58,85.773Z",
    transform: "translate(-204.598 -79.415)",
    fill: "#1a2d4c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_833-2",
    "data-name": "Ellipse 833",
    cx: 3.377,
    cy: 3.498,
    rx: 3.377,
    ry: 3.498,
    transform: "translate(21.709 0)",
    fill: "#e7e9ed"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_53685",
    "data-name": "Path 53685",
    d: "M0,0H60.238",
    transform: "translate(76.846 122.948)",
    fill: "none",
    stroke: "#e7e9ed",
    strokeLinecap: "round",
    strokeWidth: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner02);
export default __webpack_public_path__ + "static/media/banner02.b0191ff9c46bb01d516ef54e732b5fb8.svg";
export { ForwardRef as ReactComponent };